module.exports = __webpack_public_path__ + "static/media/house1lg.82dda1f5.png";